import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { ContentBoxComponent } from '../content-box/content-box.component';
import { FormsModule } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    ContentBoxComponent,
    FormsModule
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent extends BaseComponent implements OnInit {

  @Output() searchChange = new EventEmitter<string>();

  public search: string;
  public readonly search$ = new Subject<string>();

  public ngOnInit(): void {
    this.search$
      .pipe(
        debounceTime(500),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => this.searchChange.emit(value));
  }

  public resetSearch(): void {
    this.search = '';
    this.searchChange.emit('');
  }
}
